import React, { useState, createContext } from "react";
import i18n from "../i18n/i18n"

export const LanguageContext = createContext({ language: i18n.locale });
const LanguageProvider = ({children})=> {
    const [language, setLanguage] = useState(i18n.locale);
    localStorage.setItem("language", language);
    i18n.locale = language;
    const value = {language, setLanguage, i18n}
    return (
      <LanguageContext.Provider value={value}>
        {children}
      </LanguageContext.Provider>
    );
  }
export default LanguageProvider;